<template>
    <div class="segment-data-editor">
        <hh-yes-no v-if="isBoolean"
                   class="segment-data-editor__input segment-data-editor__input--bool"
                   v-model="editingValue"
                   :def="def" />
        <hh-number v-else-if="isNumber"
                   class="segment-data-editor__input segment-data-editor__input--number"
                   v-model="editingValue"
                   :def="def"
                   :allow-decimal-point="true" />
        <hh-select v-else-if="isSelection"
                   class="segment-data-editor__input segment-data-editor__input--select"
                   v-model="editingValue"
                   :def="def"
                   :options="options" />
        <hh-textbox v-else
                    class="segment-data-editor__input segment-data-editor__input--text"
                    v-model="editingValue"
                    :def="def" />
    </div>
</template>

<script>

import Casing from '../../helpers/casing'

import EditablePropertyDataItem from '../../models/editable-property-data-item'

export default {

    props: {
        value: {
            type: EditablePropertyDataItem,
            default: null,
        },
        options: {
            type: Array,
            default: () => {
                return []
            },
        },
        type: {
            type: String,
            default: 'Text',
        },
    },

    computed: {

        def() {
            return this.value && this.value.dottedString ? Casing.kebabCase(this.value.dottedString) : 'no-def'
        },

        editingValue: {
            get() {
                return this.value ? this.value.editedValue : null
            },
            set(value) {
                this.value.editedValue = value
                this.$emit('input', this.value)
            },
        },

        isBoolean() {
            return this.type === 'Boolean'
        },

        isNumber() {
            return this.type === 'Number'
        },

        isSelection() {
            return this.type === 'Selection'
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\my-home\_segment-data-editor.scss

.segment-data-editor {
    @include user-select-none;

    @include element('input') {

        @include bp-min-small {
            display: inline-block;
            width: 92%;
        }

        @include bp-min-mid {
            width: 95%;
        }

        @include bp-min-wide {
            width: 92%;
        }

        @include modifier('bool')
        {
            ul {
                li {
                    display: inline-block;

                    &:first-child {
                        input {
                            margin-left: 0.5em;
                        }
                    }
                }
            }
        }
    }
}

</style>
